import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectHomeTypesState } from '../selectors';

export const getData = createSelector(selectHomeTypesState, (state: State) => state.data);

export const getError = createSelector(selectHomeTypesState, (state: State) => state.error);

export const getLoading = createSelector(selectHomeTypesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectHomeTypesState, (state: State) => fn(state.data));
